module.exports = __webpack_public_path__ + "img/Solva_Logo.6b5b1270.svg";